import React from 'react';

import {observer} from "mobx-react";
import {OddsComparisonWidgetAsync} from "../../../odds-comparison-widget/components/odds-comparison-widget.async";

export const GameCenterWidgetContentOddsTab = observer(({controller, matchupId, gameId, location}) => {
  const {state} = controller;
  const {shouldRenderOdds} = state;

  const widgetProps = {
    matchupId,
    gameId,
    location,
  };

  return (shouldRenderOdds ? <>
    <OddsComparisonWidgetAsync {...widgetProps}/>
  </> : null)
});
